import { createClient } from '@supabase/supabase-js';

async function deriveKey(password, salt) {
  const enc = new TextEncoder();
  const keyMaterial = await crypto.subtle.importKey(
    'raw', enc.encode(password), 'PBKDF2', false, ['deriveKey']
  );
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );
}

async function decryptAES(encoded) {
  const combined = Uint8Array.from(atob(encoded), c => c.charCodeAt(0));
  const salt = combined.slice(0, 16);
  const iv = combined.slice(16, 28);
  const ciphertext = combined.slice(28);

  const key = await deriveKey('eet gavno', salt);
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv }, key, ciphertext
  );

  return new TextDecoder().decode(decrypted);
}

const supabaseUrl = 'https://exnepglwmhnvwsfrbhxi.supabase.co';
let supabaseInstance = null;

// const supabaseKey = await decryptAES(process.env.SUPABASEK);
// export const supabase = createClient(supabaseUrl, supabaseKey);

export async function getSupabase() {
  if (supabaseInstance) return supabaseInstance; // возвращаем из кеша, если уже создан

  const supabaseKey = await decryptAES(process.env.REACT_APP_SUPABASEK);
  supabaseInstance = createClient(supabaseUrl, supabaseKey);
  return supabaseInstance;
}